<app-job-invoices-retention [job]="job" (invoiceChange)="onInvoiceChange()" *ngIf="job.RetentionPercentage > 0">
</app-job-invoices-retention>

<fieldset class="panel panel-white padding-0">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Invoices</h4>
        <ul class="panel-heading-tabs border-light">
            <li class="d-flex">
                <div class="input-wrapper">
                    <i class="prefix fa-light fa-magnifying-glass"></i>
                    <input [value]="searchText()" (input)="handleSearchInput($event)" class="text-input" placeholder="Search" />
                    <button
                        id="job-invoices-contract-price-filter-search-reset"
                        class="suffix btn-flat btn-small square"
                        (click)="searchText.set('')">
                        <i class="fa-light fa-xmark"></i>
                    </button>
                </div>
            </li>
            <li *ngIf="showSyncExternalPayments">
                <div class="btn-group">
                    <button
                        [disabled]="paymentSyncRunning"
                        id="btn-sync-external-payments"
                        type="button"
                        class="btn btn-bx-primary"
                        (click)="syncExternalPayments()">
                        Sync Payments from {{ accountingProvider | uppercase }}
                    </button>
                </div>
            </li>
            <li>
                <div class="btn-group">
                    <button
                        type="button"
                        class="btn-bx-primary"
                        (click)="addInvoice()"
                        [disabled]="paymentPercentage >= 100"
                        *ngIf="permissionService.isAvailable('jobs.maintain-invoices.create-invoice')">
                        <i class="ti-plus" tooltip="Add invoice" container="body"></i>
                    </button>
                </div>
            </li>
            <li *ngIf="permissionService.isAvailable('jobs.maintain-invoices.manage-presets') && !job.PaymentTotalIncTax">
                <presets-dropdown
                    presetType="invoices"
                    (contentChange)="applyTemplate($event)"
                    [content]="invoiceTemplatePresets!"
                    placement="right"
                    class="pull-right margin-bottom-10">
                </presets-dropdown>
            </li>
            <li>
                <div class="btn-group dropdown" dropdown>
                    <button type="button" class="btn btn-default dropdown-toggle" dropdownToggle aria-haspopup="true" aria-expanded="false">
                        <i class="ti-settings"></i> <span class="caret margin-left-5"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right no-max-height" role="menu" *dropdownMenu>
                        <li *ngIf="permissionService.isAvailable('jobs.maintain-invoices.manage-payment-terms')">
                            <a (click)="termsAndConditions()"><i class="ti-comment-alt"></i> Manage Payment Terms</a>
                        </li>
                        <li *ngIf="permissionService.isAvailable('jobs.maintain-invoices.print-email-invoice-statement')">
                            <a (click)="printJobClaim()"><i class="ti-printer"></i> Print Invoice Statement</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="alert alert-info" *ngIf="remainingPercentage > 0 && remainingPercentage < 100">
            All invoices total {{ paymentTotal | bxCurrency }} / {{ paymentPercentage }}% of the adjusted contract total. You have
            <strong>{{ remainingTotal | bxCurrency }} / {{ remainingPercentage }}% remaining </strong> to create invoices for.
        </div>

        <div class="alert alert-success" *ngIf="paymentPercentage === 100">
            All invoices total {{ paymentTotal | bxCurrency }} / {{ paymentPercentage }}% of the adjusted contract total.
            <strong>You can't create any more invoices.</strong>
        </div>

        <div class="alert alert-danger" *ngIf="paymentPercentage > 100">
            All invoices total {{ paymentTotal | bxCurrency }} / {{ paymentPercentage }}% and are greater than the adjusted contract total.
            <strong>You can't create any more invoices.</strong>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="btn-group btn-group-xs" role="group">
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'All' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('All')">
                        All <span class="badge badge-light-grey">{{ invoiceCounts().all }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Pending' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Pending')">
                        Pending <span class="badge badge-light-grey">{{ invoiceCounts().pending }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Invoiced' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Invoiced')">
                        Invoiced <span class="badge badge-light-grey">{{ invoiceCounts().invoiced }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'PartReceived' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('PartReceived')">
                        Part Received <span class="badge badge-light-grey">{{ invoiceCounts().partreceived }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Received' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Received')">
                        Received <span class="badge badge-light-grey">{{ invoiceCounts().received }}</span>
                    </button>
                </div>
                <div class="form-group form-inline pull-right margin-right-5">
                    <label>Default due days:</label>
                    <input
                        legacy-css
                        class="form-control margin-left-5"
                        type="number"
                        min="0"
                        max="365"
                        required
                        [(ngModel)]="job.InvoiceDueDays"
                        (change)="saveJob()"
                        [ngModelOptions]="{ standalone: true }"
                        appNullReplace="14" />
                </div>
            </div>
        </div>

        <div class="col-xs-12 text-center" *ngIf="invoiceCounts().all == 0">
            <h2 class="margin-top-30 margin-bottom-30">Click the + button above to add a new invoice</h2>
        </div>

        <div class="form-group">
            <div *ngIf="rows()?.length" class="table-wrapper contract-price" cdkScrollable>
                <table class="material bxt-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Invoice #</th>
                            <th class="description">Description</th>
                            <th>Invoiced</th>
                            <th>Due</th>
                            <th>Contract %</th>
                            <th>Contract (Ex)</th>
                            <th>{{ 'general.variations' | translate }} (Ex)</th>
                            <th *ngIf="statusFilter() === 'PartReceived'">Balance (Inc)</th>
                            <th *ngIf="statusFilter() !== 'PartReceived'">Total (Ex)</th>
                            <th *ngIf="statusFilter() !== 'PartReceived'">{{ taxCode }}</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="changeInvoiceOrder($event)">
                        <tr *ngFor="let row of rows()" cdkDrag>
                            <td>
                                <div class="grip-container" cdkDragHandle>
                                    <span class="grip"></span>
                                </div>
                            </td>
                            <td>
                                <a
                                    [class.disabled]="paymentSyncRunning"
                                    [class.bxt-row-action]="row.InvoiceNumber !== 0"
                                    (click)="viewInvoice(row)">
                                    {{ row.InvoiceNumberString }}
                                    <i
                                        *ngIf="row.AccSyncData && row.AccSyncData !== 'blocked'"
                                        class="ti-cloud-up"
                                        tooltip="Synced to your accounting software"
                                        container="body"></i>
                                </a>
                            </td>
                            <td>
                                <a [class.disabled]="paymentSyncRunning" class="bxt-row-action" (click)="viewInvoice(row)">
                                    {{ row.Description }}
                                </a>
                            </td>
                            <td>
                                {{ row.InvoiceDate | date }}
                            </td>

                            <td>
                                {{ row.DueDate | date }}
                            </td>
                            <td>
                                {{ row.PercentageOfTotal | number: '1.2-2' }}
                            </td>
                            <td>
                                {{ row.PaymentValue | bxCurrency }}
                            </td>
                            <td>
                                {{ row.VariationsValue | bxCurrency }}
                            </td>
                            <td *ngIf="statusFilter() === 'PartReceived'">
                                {{ row.BalanceTotalIncTax | bxCurrency }}
                            </td>
                            <td *ngIf="statusFilter() !== 'PartReceived'">
                                {{ row.Total + row.Adjustment | bxCurrency }}
                            </td>
                            <td *ngIf="statusFilter() !== 'PartReceived'">
                                {{ row.GST | bxCurrency }}
                            </td>
                            <td>
                                <span
                                    class="label"
                                    [ngClass]="{
                                        'label-inverse': row.Status === 'Pending',
                                        'label-warning': row.Status === 'Invoiced',
                                        'label-info': row.Status === 'PartReceived',
                                        'label-success': row.Status === 'Received',
                                    }"
                                    >{{ row.Status }}</span
                                >
                            </td>
                            <td>
                                <button
                                    [disabled]="paymentSyncRunning"
                                    type="button"
                                    class="btn btn-xs btn-info margin-left-5"
                                    (click)="addReceipt(row)"
                                    tooltip="Add Payment Receipt"
                                    container="body"
                                    [adaptivePosition]="false"
                                    *ngIf="
                                        permissionService.isAvailable('jobs.maintain-invoices.add-payment-receipt') &&
                                        (row.Status === 'Invoiced' || row.Status === 'PartReceived')
                                    ">
                                    <i class="ti-receipt"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-xs btn-default margin-left-5"
                                    (click)="shareInvoice(row)"
                                    tooltip="Share"
                                    container="body"
                                    [adaptivePosition]="false">
                                    Share
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-xs btn-default margin-left-5"
                                    (click)="printInvoice(row)"
                                    tooltip="Print"
                                    container="body"
                                    [adaptivePosition]="false"
                                    *ngIf="permissionService.isAvailable('jobs.maintain-invoices.print-email-invoice')">
                                    <i class="ti-printer"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-xs btn-danger margin-left-5"
                                    (click)="deleteInvoice($event, row)"
                                    [disabled]="row.Status !== 'Pending'"
                                    tooltip="Delete"
                                    container="body"
                                    [adaptivePosition]="false"
                                    *ngIf="permissionService.isAvailable('jobs.maintain-invoices.delete-invoice')">
                                    <i class="ti-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</fieldset>
